<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Flavor"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-flavor">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
